import { createSvgIcon } from '@mui/material/utils'

const ArrowDown = createSvgIcon(
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.29004 9.99617L3.29004 5.99617L3.99715 5.28906L7.99715 9.28906L11.9971 5.28906L12.7043 5.99617L8.70425 9.99617L7.99715 10.7033L7.29004 9.99617Z"
    />
  </>,
  'ArrowDown'
)

export default ArrowDown
